export function toTitleCase(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

// "2026-06-29T00:15:23.630Z" → browser locale + timezone, e.g. "Jun 29 2026, 01:31 PM NZST"
export function formatTimeLocal(isoTime: string): string {
  if (!isoTime) return '';
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }).format(new Date(isoTime));
}

export function tryParseJSON(str: string): object | null {
  if (!str || (str[0] !== '{' && str[0] !== '[')) return null;
  try {
    const v: unknown = JSON.parse(str);
    return typeof v === 'object' && v !== null ? v : null;
  } catch {
    return null;
  }
}
